import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import CruiseUrgencyLabel from 'components/Cruises/Common/CruiseUrgencyLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import type { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import { isCruiseV1Offer } from 'lib/offer/offerTypes'
import React, { useMemo } from 'react'
import AgentHubAdditionalCommissionLabel from 'agentHub/components/AgentHubAdditionalCommissionLabel'

interface Props {
  view: CruiseOfferView
}

function CruiseSearchTileLabels({ view }: Props) {
  // Filter out 'sale' type labels as they're shown in the features section
  const filteredUrgencyLabels = useMemo(() => {
    return view.urgencyLabels.filter(label => label.type !== 'sale')
  }, [view.urgencyLabels])

  return <LabelGroup>
    {filteredUrgencyLabels.map(label => <CruiseUrgencyLabel
      key={label.type}
      offer={view.offer}
      label={label}
    />)}
    <AgentHubAdditionalCommissionLabel offerId={view.offer?.id} />
    {isCruiseV1Offer(view.offer) && view.offer.badge && <OfferBadgeLabel badge={view.offer.badge} />}
  </LabelGroup>
}

export default CruiseSearchTileLabels
